import React, { Component } from 'react';
import { Row, Col, Table } from "react-bootstrap";
import Select from 'react-select';
import { toast } from 'react-toastify';

import { CustomCard } from "../../../components/Card/CustomCard";
import { consultCarreras } from '../../../funciones/MateriasFunction';
import { ListAdmisionE } from '../../../funciones/AdmisionFunction';

import ModalReports from '../../../components/Reportes/ModalReports';
import ModalListAdmision from '../../../components/Reportes/ModalListAdmision';
import ListAdmisionTable from './ListAdmisionTable';

class ListAdmision extends Component {
    state = {
        carreraSelect: { value: "", label: '- Selecciona -' },
        carrera: [],
        loadCarrera: true,
        listEst:[],
        preloader: <React.Fragment>Selecciona una Carrera</React.Fragment>,
        openModal: false,
        boton1: {
            icon: "fa fa-print",
            text: "Imprimir",
            disabled: false
        }
    }

    constructor(props){
        super(props)
        consultCarreras ((resp) => {
            this.setState({
                carrera: resp,
                loadCarrera: false
            })
        })
    }

    imprimir = () => {
        switch(true){
            case (this.state.carreraSelect.value === ""):
                toast.error("Debes seleccionar primero una carrera",{autoClose: 4000});
            break
            default:
                this.setState({openModal: true})
            break
        }
    }

    cambiaCarreras = (carreraSelect) => {
        this.setState({
            carreraSelect,
            preloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Buscando</React.Fragment>,
            listEst: [],
            boton1: {
                icon: "fa fa-spinner fa-spin",
                text: "Espera",
                disabled: true
            }
        }, () => {
            ListAdmisionE(carreraSelect.value, (resp)=> {
                let pre = ""
                if (resp.Estudiantes.length === 0) pre = <React.Fragment><i className="fa fa-times"></i> No hay estudiates de nuevo ingreso en la carrera seleccionada</React.Fragment>
                this.setState({
                    preloader: pre,
                    listEst: resp.Estudiantes,
                    boton1: {
                        icon: "fa fa-print",
                        text: "Imprimir",
                        disabled: false
                    }
                })
            })
        })
    }

    contenido = () => {
        let { carreraSelect, carrera, loadCarrera, preloader, listEst, boton1 } = this.state;

        const customStyles = {
            menu: (provided) => ({
              ...provided,
              zIndex: 10,
            })
        }

        const styles = {
            padding: 5, fontSize: 12
        }

        let lista = () => {
            if (listEst.length === 0) return (
                <tr>
                    <td align="center" colSpan={5} style={styles}>{preloader}</td>
                </tr>
            )

            let n = 0;
            return(
                listEst.map(option => {
                    n++;
                    return(
                        <ListAdmisionTable key = {option.Datos.id}
                        Datos = {option.Datos}
                        Materia = {option.Materias} N = {n}
                        Estudiante = {`${option.Datos.nombre_1} ${option.Datos.nombre_2} ${option.Datos.apellido_1}  ${option.Datos.apellido_2}`}
                        EstCuenta = {this.props.estCuenta}
                        Semestres = {option.Semestres}
                        SemAlto = {option.SemActual}/>
                    )
                })
            )
        }

        return (
            <Row>
                <Col md = {9} className="custom-mt-10">
                    <div className="custom-alert-info">
                        <Row>
                            <Col md={6} style={{paddingTop: 10,}}>
                                Selecciona una carrera
                            </Col>
                            <Col md={6}>
                                <Select
                                    isLoading={loadCarrera}
                                    styles={customStyles}
                                    isSearchable ={true}
                                    value={carreraSelect}
                                    onChange={this.cambiaCarreras}
                                    options={carrera}
                                />
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col md = {3} className="custom-mt-10" align="right">
                    <button className="btn btn-primary" onClick ={this.imprimir} style={{borderWidth: 1}}><i className={boton1.icon}></i> {boton1.text}</button>
                </Col>
                <Col md={12} className="custom-mt-10">
                    <div className="table-responsive">
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td width="40px" style={styles} align="center"><strong>N°</strong></td>
                                    <td width="80%" style={styles}><strong>Estudiante</strong></td>
                                    <td width="20%" style={styles} align="center"><strong>Lugar</strong></td>
                                    <td width="100px" style={styles} align="center"><strong>Materias</strong></td>
                                    <td width="10%" style={styles} align="center"><strong></strong></td>
                                </tr>
                                {lista()}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </Row>
        )
    }

    ayuda = () => (
        <Row>
            <Col md ={12} align="justify">
                En este módulo puedes ver e imprimir todos los estudiantes <strong>Nuevo Ingreso</strong> de cada una de las carreras
            </Col>
            <Col md ={12} align="justify" className="custom-mt-10">
                Para ver el listado primero selecciona una carrera y espera que cargue el listado de estudiantes
            </Col>
            <Col md ={12} align="justify" className="custom-mt-10">
                En el listado puedes observar los datos del estudiante (Cédula, Nombre y Apellido, Correo y Teléfonos), el Lugar de Nacimiento y la Cantidad de Materias Inscritas 
            </Col>
            <Col md ={12} align="justify" className="custom-mt-10">
                El botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-print"></i> Imprimir</button> permite generar el listado en formato <strong>.pdf</strong> para su impresión o descarga
            </Col>
            <Col md={12} align="justify">
                El botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-chevron-right"></i></button> Muestra las opciones disponibles (Registrar Pago, Ver Estado de Cuenta y Ver Materias Inscritas)
            </Col> 
        </Row>
    )

    showModal = () => {
        if (this.state.openModal === false) return null;
        if (this.state.boton1.disabled === true) return null;
        return (
            <ModalReports
                reporte={<ModalListAdmision titulo = "Listado de Estudiantes de Nuevo Ingreso" data = {this.state.listEst} carrera = {this.state.carreraSelect.label}/>}
                titulo="Listado de Estudiantes de Nuevo Ingreso"
                display= "block"
                cerrar = {() => {this.setState({openModal: false})}}
            />
        )
    }

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Listado de Nuevo Ingreso</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.showModal()}
            </div>
        );
    }
}
 
export default ListAdmision;


// WEBPACK FOOTER //
// ./src/views/AdmisionAdmin/AdmisionAdminContent/ListAdmision.jsx